import {StoreHeaderModel} from "../../models/storeHeader";
import React from "react";
import {ImageUtils} from "../../utils/imageUtils";
import {Image} from "../images/Image";
import {Body, HeroHeading2} from "../text";
import Skeleton from "react-loading-skeleton";

export interface StoreHeaderViewProps {
  storeHeader?: StoreHeaderModel
  loading: boolean
}

export const StoreHeaderView: React.FC<StoreHeaderViewProps> = ({ storeHeader, loading }) => {
  const coverImageUrl = ImageUtils.createUrlFromImage(storeHeader?.coverImage, )
  const iconImageUrl = ImageUtils.createUrlFromImage(storeHeader?.iconImage, { heightPx: 200, widthPx: 200 })

  return (
    <div>
      {
        (() => {
          if (coverImageUrl && iconImageUrl) {
            return <div className="relative">
              {loading ? <Skeleton height="0px" className="!aspect-h-1 !aspect-w-5 !h-screen-1/6 !rounded-lg" /> : <Image
                src={coverImageUrl}
                alt={storeHeader?.title + " Cover Photo"}
                layout={"fill"}
                objectFit={"cover"}
                sizeClass="aspect-h-1 aspect-w-5 h-screen-1/6"
                className="rounded-lg bg-fg-gray-surface"
              /> }
              <div className="absolute left-2 md:left-4 lg:left-6 bottom-0 -mb-6 h-12 w-12 md:-mb-8 md:h-16 md:w-16 lg:-mb-10 lg:h-20 lg:w-20 rounded-full ring-2 lg:ring-4 ring-white shadow-xl">
                {loading ? <Skeleton className="!h-full !w-full !rounded-full !absolute" /> : <Image
                  src={iconImageUrl}
                  alt={storeHeader?.title + " Logo"}
                  layout={"fill"}
                  objectFit={"contain"}
                  sizeClass="aspect-h-1 aspect-w-1 h-full w-full"
                  className="rounded-full bg-fg-gray-surface"
                /> }
              </div>
            </div>
          } else if (loading) {
            return <div className="relative">
              <Skeleton height="0px" className="!aspect-h-1 !aspect-w-5 !h-screen-1/6 !rounded-lg" />
              <div className="absolute left-2 md:left-4 lg:left-6 bottom-0 -mb-6 h-12 w-12 md:-mb-8 md:h-16 md:w-16 lg:-mb-10 lg:h-20 lg:w-20 rounded-full ring-2 lg:ring-4 ring-white shadow-xl">
                <Skeleton className="!h-full !w-full !rounded-full !absolute" />
              </div>
            </div>
          } else {
            return null
          }
        })()
      }

      <div className="mx-2 md:mx-4 lg:mx-6 mt-12 md:mt-16 lg:mt-20">
        <HeroHeading2>{loading ? <Skeleton width="30%" /> : storeHeader?.title}</HeroHeading2>
        <Body className="mt-4 text-fg-gray-dark">{loading ? <Skeleton width="50%" /> : storeHeader?.subtitle}</Body>
      </div>

    </div>
  )
}